<template>
  <div ref="carouselContent" class="custom-carousel">
    <swiper
      v-if="displayHighlight"
      :options="swiperOption"
      :dir="$vs.rtl ? 'rtl' : 'ltr'"
      :key="$vs.rtl"
    >
      <swiper-slide
        v-for="(item, index) in data"
        :key="index"
        class="cursor-pointer custom-card-carousel flex"
        :class="{ 'highlight-item-selected-mosaic': isItemSelected(item) }"
        @click.stop="openReportDetail(item)"
      >
      
        <vs-card
          class="highlight-card mosaic"
          :class="{ 'highlight-invite': isDisclosureInvite(item) }"
        >
        
          <div
            slot="header"
            class="highlight-header-div mosaic"
            @click.stop="openReportDetail(item)"
          >
          <div class="flex w-full">
                    <div class="name-commoditie bold w-full">
                      {{ hat(item) }} 
                      <!-- Agricultura de Precisão -->
                    </div>
                    <div class="date-high">
                      <template v-if="!isAuthenticated">
                        <div class="item-date" v-if="!isItemNews(item)">{{ formatDate(item.dt_publish, {dateStyle: "short"}) }}</div> 
                        <div class="item-date" v-if="isItemNews(item)">{{ formatDate(item.dt_publish, {dateStyle: "short"}) }}</div>
                      </template>
                      <template v-else>
                        <div class="item-date" v-if="!isItemNews(item)" >{{ formatDate(item.dt_report, {dateStyle: "short"}) }}</div> 
                        <div class="item-date" v-if="isItemNews(item)">{{ formatDate(item.data_object, {dateStyle: "short"}) }}</div>  
                      </template>
                    </div>
                </div>
          
          
            <div class="mosaic-badges">
              <div class="" >
                <div class="badge live" v-if="item.inLive">
                    <div class="badge-wrap">
                        <span class="badge-icon">
                          <svg height="14" viewBox="0 0 14 14" width="14" xmlns="http://www.w3.org/2000/svg">
                            <path d="M7 2.333c2.577 0 4.667 2.09 4.667 4.667S9.577 11.667 7 11.667 2.333 9.577 2.333 7 4.423 2.333 7 2.333zm0 1.05c-1.997 0-3.617 1.62-3.617 3.617 0 1.997 1.62 3.617 3.617 3.617 1.997 0 3.617-1.62 3.617-3.617 0-1.997-1.62-3.617-3.617-3.617z"></path></svg><span class="badge-icon-inner"><svg aria-hidden="true" focusable="false" viewbox="0 0 14 14"><path d="M7 9.567c1.418 0 2.567-1.15 2.567-2.567 0-1.418-1.15-2.567-2.567-2.567-1.418 0-2.567 1.15-2.567 2.567 0 1.418 1.15 2.567 2.567 2.567z"></path>
                          </svg>
                        </span>
                      </span>
                      <span class="">{{$t('BADGES').InLive}}</span>
                    </div>
                  </div>
                  <div class="badge bd-imp" v-if="isImportant(item) && !item.inLive">
                    <div class="badge-wrap"> 
                      <span class="badge-text">{{$t('BADGES').Important}}</span>
                    </div>
                  </div>
                  <div class="badge disclosure-announcement-badge" v-if="isDisclosureAnnouncement(item)">
                    <div class="badge-wrap"> 
                      <span class="badge-text">{{$t('BADGES').Announcement}}</span>
                    </div>
                  </div>
                  <div class="badge disclosure-invite-badge" v-if="isDisclosureInvite(item)">
                    <div class="badge-wrap"> 
                      <span class="badge-text">{{$t('BADGES').Invite}}</span>
                    </div>
                  </div>

                
              </div>
              
              <div class="w-full">
                
                <div class="img-high mosaic msc2 mt-1" :style="getThumbPathStyle(item)">
                </div>
                <!-- <div class="title-highlights flex">
                  <h5 class="pl-0 pt-2 hat">{{ hat(item) }}</h5>
                </div> -->
                <div class="title-highlights-content pt-2" >
                  {{ getTitle(item) }}
                </div>
                <div class="author-flex mt-2">
                  <author-info v-if="item.author" :displayNickname="true" class="author cursor-pointer w-full mt-3 mb-3 flex author-high" :author="item.author" @open-author="$emit('open-author', $event)"></author-info>
                </div> 
                  <div class="hr-actions"></div>
                <div class="flex actions-bar actions-bar-high" @click.prevent="openReportDetail(item)">
                  <div class="flex icons-details items-center">
                    <action-icons-field
                      :data="item" 
                      :isAuthenticated="isAuthenticated" 
                      :isDesktop="isDesktop"
                      :isItemNews="isItemNews(item)"
                      :canDisplayPreview="canDisplayPreview(item)"
                      :iconReferencePreview="false"
                      @addPlaylist="addPlaylist"
                      @playMultimedia="playMultimedia"
                      @onDownloadFile="onDownloadDocument"
                      @open-exclusive-content="$emit('open-exclusive-content')"
                      @save-schedule-news="$emit('save-schedule-news', item)">
                    </action-icons-field>
                    
                  </div>
                </div>
                
              </div>
            </div>
            
          </div>
          <!-- <div class="" @click="openReportDetail(item)">
          </div> -->
          
          
        </vs-card>
      
      </swiper-slide>
    </swiper>
    <div class="swiper-pagination swiper-pagination-custom" slot="pagination"></div>
  </div>
</template>

<script>
  import DropdownUserInfo from '../widgets/dropdown-user-info/DropdownUserInfo.vue';
  import "swiper/dist/css/swiper.min.css";
  import {swiper, swiperSlide} from "vue-awesome-swiper";
  import { CONTENT } from '../../../enums/enum-content';
  import AppConstants from '../../../appConstants';
  import translateFieldHelper from '../../../helpers/translate-field-helper';
import formatFieldHelper from '../../../helpers/format-field-helper';
import generalHelper from '../../../helpers/general-helper';
import AuthorInfo from '../../../layouts/components/customizer/AuthorInfo.vue';
import convertDatetimeHelper from '../../../helpers/convert-datetime-helper';
import ActionIconsField from '../../../layouts/components/customizer/ActionIconsField.vue';
import { EventBus } from '../../../event-bus';

export default {
  props: {
    data: {
      type: Array,
      required: true
    },
    currentCommodity: {
      require: true
    },
    isAuthenticated: {
      type: Boolean,
      require: true
    },
    currentSelected: { type: Object }
  },
  data() {
    return {
      displayHighlight: false,
      swiperOption: {
        slidesPerView: 0,
        spaceBetween: 5,
        pagination: {
          el: ".swiper-pagination",
          clickable: true
        },
      }
    };
  },
  computed: {
    isReport() {
      return (
        this.data.newsContent.findIndex(
          item =>
            item.code == CONTENT.INFORMATIVE ||
            item.code == CONTENT.EXPORTS ||
            item.code == CONTENT.STATISTIC
        ) >= 0
      );
    },
    isCardView() {
      return this.$store.state.reportViewStyle === AppConstants.REPORT_VIEW_STYLE.CARDVIEW;
    },
    isMosaicView() {
      return this.$store.state.reportViewStyle === AppConstants.REPORT_VIEW_STYLE.MOSAIC;
    },
    isListViewDetailed() {
      return this.$store.state.reportViewStyle === AppConstants.REPORT_VIEW_STYLE.LISTVIEW_DETAILED;
    },
    // swiperOption() {
    //   return {
    //     slidesPerView: this.getSlidesPerView(),
    //     spaceBetween: 5,
    //     pagination: {
    //       el: ".swiper-pagination",
    //       clickable: true
    //     },
    //   }
    // },
    isDesktop() {
      return this.$store.state.isDesktop;
    },
    windowWidth() {
      return this.$store.state.windowWidth;
    },
    AppActiveUser() {
      return this.$store.state.AppActiveUser;
    },
    carouselWidth() {
      return this.$refs['carouselContent'] ? this.$refs['carouselContent'].offsetWidth : null;
    }
  },
  watch: {
    windowWidth() {
      this.updateSlides();
    },
  },
  created() {
    this.updateSlides();
    EventBus.$on(AppConstants.BUS_EVENT_UPDATE_HIGHLIGHTS, this.updateSlides);
  },
  methods: {
    updateSlides() {
      const slides = this.getSlidesPerView();
      // console.log('[updateSlides]', slides);
      // console.log('[carouselWidth]', this.carouselWidth);
      if (this.swiperOption.slidesPerView != slides) {
        this.swiperOption.slidesPerView = slides;
        this.displayHighlight = false;
        setTimeout(() => {
          this.displayHighlight = true;
          this.$forceUpdate();
        }, 50);
      }
      this.$forceUpdate();
    },
    canDisplayPreview(data) {
      return (data.content.abstract || data.content.text) && this.isDesktop;
    },
    getSlidesPerView() {
      if (!this.isDesktop) {
        if (this.windowWidth > 800) return 3;
        if (this.windowWidth > 600 && this.windowWidth < 800) return 2;
        return 1;
      }
      // console.log('getSlidesPerView', this.isMosaicView)
      if (this.windowWidth > 1700) {
        if (this.isMosaicView) return 5;
        return 2;
      }
      if (this.windowWidth > 1200 && this.windowWidth < 1700) {
        if (this.isMosaicView) return 4;
        return 2;
      }
      if (this.windowWidth > 800 && this.windowWidth < 1200) {
        return 3;
      } 
      if (this.windowWidth < 800) {
        return 2;
      } 
      // if (this.windowWidth > 1336 && this.windowWidth < 1700) {
      //   return 1;
      // }
      
      return 2;
    },
    formatFullDate(val, obj) {
      return convertDatetimeHelper.formatFullDate(val, obj);
    },
    formatDate(val, obj) {
      return convertDatetimeHelper.formatDate(val, obj);
    },
    canSpeechText(data) {
      return generalHelper.canSpeechText(data, this.isDesktop);
    },
    onDownloadDocument(data) {
      this.$emit("onDownloadFile", data);
    },
    playMultimedia({data, isTextSpeech}) {
      this.$emit("playMultimedia", {
        data: data,
        isTextSpeech: isTextSpeech
      });
    },
    getIconCard(data) {
      if (data.youtubeId) {
        return "VideoIcon";
      } else if (data.audio || data.spotify || data.soundcloud) {
        return "MicIcon";
      } else if (data.document) {
        return "PaperclipIcon";
      } else {
        return null;
      }
    },
    hasMultimedia(data) {
      return (!!data.youtubeId || !!data.audio || !!data.spotify || !!data.soundcloud)
    },
    addPlaylist(data) {
      this.$store.dispatch("insertItemPlaylist", data);
    },
    canAddPlaylist(data) {
      return (!!data.youtubeId || !!data.audio || !!data.spotify || !!data.soundcloud) && this.isAuthenticated;
    },
    getTitle(item) {
      if (!item) return '';
      if (item.newsContent[0].code == CONTENT.STATISTIC ||
        item.newsContent[0].code == CONTENT.EXPORTS ||
        item.newsContent[0].code == CONTENT.INFORMATIVE) {
          return translateFieldHelper.getTranslateField('name', item.reportType);
        }
      return formatFieldHelper.limitFieldLength(item.content.title.data, AppConstants.HIGHLIGHTS_TITLE_LIMIT_LENGTH);
    },
    isImportant(item) {
      if (!item) {
        return false;
      }
      return item.importance > 0;
    },
    isDisclosureAnnouncement(item) {
      return (item.disclosureType == AppConstants.DISCLOSURE_TYPE_ENUM.ANNOUNCEMENT);
    },
    isDisclosureInvite(item) {
      return (item.disclosureType == AppConstants.DISCLOSURE_TYPE_ENUM.INVITE);
    },
    headerStyle(item) {
      try {
        let commodityFile = '';
        let originCode = formatFieldHelper.getOriginCode(this.AppActiveUser);
        if (this.currentCommodity.id && this.currentCommodity.id > 0) {
          commodityFile = require(`../../../assets/images/commodity/${originCode}/${this.currentCommodity.id}.png`);
        } else {
          commodityFile = require(`../../../assets/images/commodity/${originCode}/${item.subjects[0].code}.png`);
        }
        return `background-image: url("${commodityFile}");`;
      } catch (e) {
          // console.log(e);
        return "";
      }
    },
    getThumbPathStyle(item) {
      if (item.thumb) {
        return `background-image:url('${item.thumb.image_path}')`;
      }
      return this.headerStyle(item);
    },
    hat(item) {
      if (item) {
        if (item.hat[0]) {
          return item.hat[0].name.toUpperCase();
        }
      }
      return "";
    },
    isItemSelected(item) {
      if (!this.currentSelected) return false;
      return item._id == this.currentSelected._id;
    },
    isItemNews(data) {
      if (data.newsContent[0]) {
        if (data.newsContent[0].code == CONTENT.NEWS) {
          return true;
        }
      }
      return false;
    },
    getTranslateData(data) {
      return data[`name${this.$i18n.locale}`];
    },
    getSubjectName(subjects) {
      return translateFieldHelper.getSubjectName(subjects, this.currentCommodity);
    },
    getSubjectIcon(subjects) {
      if (this.currentCommodity.id) {
        const sub = subjects.find(item => item.code == this.currentCommodity.id);
        if (sub) {
          return sub.icon;
        }
      }
      return subjects[0].icon;
    },
    isReportDateToday() {
      if (this.report) {
        return this.report.data_object.getUTCDate() == new Date().getUTCDate();
      }
      return false;
    },
    openReportDetail(report) {
      this.$emit('openReportDetail', report);
    },
    getManchete(report) {
      if (report.hat[0]) {
        return report.hat[0].name;
      }
      return '';
    }
  },
  beforeDestroy() {
    EventBus.$off(AppConstants.BUS_EVENT_UPDATE_HIGHLIGHTS);
  },
  components: {
    DropdownUserInfo,
    swiper,
    swiperSlide,
    AuthorInfo,
    ActionIconsField
  }
};
</script>

<style>

</style>
